<template>
  <div class="content">
    <div id="map"></div>
    <div class="map-filter">
      <!-- <el-select class="e-select e-select-first" v-model="formData.valOperator" :placeholder="$t('g.choose')">
          <el-option
            v-for="item in operators"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
      </el-select> -->
      <el-cascader style="width: 210px;margin-right: 0.5rem;" :clearable="true" v-model="formData.CodePathID"
        :props="formData.props" :options="cascade_options_direct" :placeholder="$t('decision.tips.agent_code')" />
      <el-select :placeholder="$t('decision.input_name')" popper-class="e-search" class="e-select"
        v-model="formData.search" filterable>
        <el-option v-for="item in formData.data" :key="item.id" :label="item.name" :value="item.id">
          <span class="option-custom">
            <span class="option-label">{{ item.name }}</span>
            <span class="option-address">{{ item.address }}</span>
          </span>
        </el-option>
      </el-select>
    </div>
    <div class="map-options">
      <el-radio v-model="formData.type" label="all">{{ $t('device.types.all') }}</el-radio>
      <el-radio v-model="formData.type" label="ebox">{{ $t('device.types.ebox') }}</el-radio>
      <el-radio v-model="formData.type" label="cbox">{{ $t('device.types.cbox') }}</el-radio>
      <el-radio v-model="formData.type" label="pile">{{ $t('device.types.pile') }}</el-radio>
      <el-radio v-model="formData.type" label="cpbox">{{ $t('device.types.cpbox') }}</el-radio>
      <el-switch v-model="formData.online" active-color="#13ce66">
      </el-switch>
      <span class="switch-txt switch-txt-online">{{ $t('device.statuses.online') }}</span>
      <el-switch v-model="formData.offline" active-color="#ff4949">
      </el-switch>
      <span class="switch-txt switch-txt-offline">{{ $t('device.statuses.offline') }}</span>
    </div>
    <div class="eq-box-ct" v-show="formData.showEQBox" @click="func.doHideEQBox">
      <div class="eq-box" @click.stop="">
        <div class="title">{{ formData.curData.name }}</div>
        <div class="item">
          <span class="label">{{ $t('device.online_status') }}:</span>
          <span
            :class="{ 'status': true, 'val': true, 'active': formData.curData.status === $t('device.statuses.online') }">{{
              formData.curData.status }}</span>
        </div>
        <div class="item">
          <span class="label">{{ $t('device.agent') }}:</span>
          <span class="val">{{ formData.curData.agentCode }}</span>
          <span class="label" v-if="formData.curData.deposit">{{ $t('device.deposit') }}:</span>
          <span class="val" v-if="formData.curData.deposit">{{ formData.curData.deposit }}</span>
        </div>
        <div class="item">
          <span class="label" v-if="formData.curData.chargeMoney">{{ $t('device.moneys.charge') }}:</span>
          <span class="val" v-if="formData.curData.chargeMoney">{{ formData.curData.chargeMoney }}/时</span>
          <span class="label" v-if="formData.curData.saveMoney">{{ $t('device.moneys.save') }}:</span>
          <span class="val" v-if="formData.curData.saveMoney">{{ formData.curData.saveMoney }}</span>
        </div>
        <div class="item">
          <span class="label">{{ $t('device.site_name') }}:</span>
          <span class="val">{{ formData.curData.siteName }}</span>
        </div>
        <div class="item">
          <span class="label">{{ $t('device.no') }}:</span>
          <span class="val">{{ formData.curData.devId }}</span>
        </div>
        <div class="item">
          <span class="label">{{ $t('device.address') }}:</span>
          <span class="val">{{ formData.curData.address }}</span>
        </div>
        <div class="img-ct">
          <el-image :preview-src-list="formData.curData.imgs" class="img" v-for="(item, idx) in formData.curData.imgs"
            :key="idx" :src="item" />
        </div>
        <div id="chart" class="chart"></div>
      </div>
    </div>
    <div class="cluster-list-ct" v-show="formData.visible" @click="func.doHideClusterList">
      <div class="cluster-list" @click.stop="">
        <div class="cluster-title">{{ formData.title }}</div>
        <div class="cluster-item" v-for="(item, idx) in formData.list" :key="item.id" @click="handleClusterItemClick(item.id)">
          <div class="name">{{ item.name }}</div>
          <div class="meta">{{ item.devId }} · {{ item.address }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { getEqs } from '@/data/Equipments'
import ClusterBubble from '@/data/ClusterBubble'
import { onMounted, watch, onBeforeUnmount, reactive, nextTick } from 'vue'
import { getCoord } from '@/data/default'
import * as echarts from 'echarts'
import i18n from '@/data/i18n/index'
import { operators, cascade_options_direct } from '@/data/default'
import axios from 'axios'
export default {
  name: 'AnalysisDistributionPoints',
  setup() {
    const t = i18n.global.t
    const AMap = window.AMap
    let map = null
    let marker = null
    let markerCluster = null
    let markerGeometries = []
    let clusterBubbleList = []
    let myChart = null // 图表
    let allEQs = [] //所有设备
    const formData = reactive({
      type: 'all',
      search: '',
      data: [],
      online: true,
      offline: true,
      curData: {},
      CodePathID: 0,
      showEQBox: false,
      props: {
        children: "Children", expandTrigger: 'hover',
        label: "Name",
        value: "Id",
        emitPath: false,
        checkStrictly: true
      },
      visible: false,
      title: '',
      list: []
    })
    const func = {}

    func.doHideEQBox = () => {
      formData.showEQBox = false
      formData.search = ''
      for (const idx in formData.data) {
        formData.data[idx].active = false
      }
      // 同时关闭聚合列表
      func.doHideClusterList()
    }
    func.doHideClusterList = () => {
      formData.visible = false
      formData.list = []
      formData.title = ''
    }
    const handleClusterItemClick = (id) => {
      // 显示列表里的设备详情
      doShowEQBox(id, false)
    }
    const doShowEQBox = async (id, focus = true) => {
      for (const idx in formData.data) {
        const item = formData.data[idx]

        if (item.id === id) {
          formData.curData = item
          formData.showEQBox = true
          formData.data[idx].active = true
          // 等待 DOM 更新后再初始化 chart 避免宽高为 0 的报错
          await nextTick()
          try {
            const chartDom = document.getElementById('chart')
            if (chartDom && chartDom.clientWidth > 0 && chartDom.clientHeight > 0) {
              if (!myChart) myChart = echarts.init(chartDom)
              setChart(item.slotNum, item.slotNumEm, item.slotNumErr)
            } else {
              // 如果依然为 0，可延迟尝试一次
              setTimeout(() => {
                try {
                  const cd = document.getElementById('chart')
                  if (cd && cd.clientWidth > 0 && cd.clientHeight > 0) {
                    if (!myChart) myChart = echarts.init(cd)
                    setChart(item.slotNum, item.slotNumEm, item.slotNumErr)
                  }
                } catch (err) { console.warn('delayed chart init failed', err) }
              }, 100)
            }
          } catch (err) {
            console.warn('init chart error', err)
          }
          if (focus) {
            map.setZoomAndCenter(12, [item.lng, item.lat])
            return
          }

        }
      }
    }
    const getDataById = (id) => {
      for (const item of formData.data) {
        if (item.id === id) {
          return item
        }
      }
      return {}
    }
    const dataFilter = async () => {
      
      allEQs = await getEqs()
      formData.data = Object.assign([], allEQs)
      let typeId = 0
      if (formData.type != 'all') {
        if (formData.type == 'cpbox') {
          typeId = 4
        } else {
          typeId = formData.type === 'pile' ? 3 : (formData.type === 'ebox' ? 1 : 2)
        }
      }
      let res = []
      for (const item of allEQs) {
        if (item.type === typeId || typeId === 0) {
          if (formData.online && item.status === t('device.statuses.online')) {
            res.push(item)
          } else if (formData.offline && item.status === t('device.statuses.offline')) {
            res.push(item)
          }
        }
      }
      //查运营商
      // if (formData.valOperator) {
      //   let newRes = []
      //   // for(const item of res){
      //   //   if(formData.valOperator == item.agentCode){
      //   //     newRes.push(item)
      //   //   }
      //   // }
      //   newRes = res.filter(item => item.CodePath.includes(formData.valOperator));
      //   res = newRes
      // }
      // 更新地图标记
      const geometries = []
      for (const item of res) {
        const marker = new AMap.Marker({
          position: [item.lng, item.lat],
          clickable: true,
          extData: {
            id: item.id
          },
          icon: getMarkerIcon(item)
        })
        marker.on("click", (e) => {
          doShowEQBox(e.target.w.extData.id, false)
        })
        geometries.push(marker)
      }
      console.log("geometries", geometries)
      if (markerCluster && typeof markerCluster.setMarkers === 'function') {
        markerCluster.setMarkers(geometries)
      } else {
        markerGeometries = geometries
      }

      formData.data = res
    }

    watch([
      () => formData.type,
      () => formData.online,
      () => formData.offline,
      () => formData.CodePathID,
    ], () => {
      dataFilter()
    })
    watch(() => formData.search, () => {
      if (formData.search) {
        doShowEQBox(formData.search)
      }
    })
    const setChart = (total = 0, em = 0, err = 0) => {
      const option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'center'
        },
        series: [
          {
            name: t('device.status'),
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '30',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              { value: total - em - err, name: t('device.sp_battery') },
              { value: em, name: t('device.sp_empty') },
              { value: err, name: t('device.sp_error') },
            ]
          }
        ]
      }
      if (myChart) myChart.setOption(option)
    }
    const initMap = async () => {
      const coord = await getCoord()
      const center = [coord.lng, coord.lat]
      // 初始化地图
      map = new AMap.Map('map', {
        zoom: 12, // 设置地图缩放级别
        // pitch: 40, // 设置地图俯仰角
        center, // 设置地图中心点坐标
        resizeEnable: true,
        mapStyle: 'amap://styles/f9db5bb4478d355b9c1fc70c756671c8',
        features: ['bg', 'road'],
      })
      // 点数据
      const geometries = []
      console.log("formData.data", formData.data)
      for (const item of formData.data) {
        const marker = new AMap.Marker({
          position: [item.lng, item.lat],
          clickable: true,
          extData: {
            id: item.id
          },
          icon: getMarkerIcon(item)
          // content:""
        })
        marker.on("click", (e) => {
          console.log("e1111", e)
          doShowEQBox(e.target.w.extData.id, false)
        })
        geometries.push(marker)
      }
      // 创建点聚合实例
      markerCluster = new AMap.MarkerClusterer(map, geometries, {
        gridSize: 60,
      })

      // 监听聚合点点击
      try {
        markerCluster.on && markerCluster.on('click', (e) => {
          try {
            let markers = []
            const totalCount = formData.data ? formData.data.length : 0
            if (e && e.cluster && typeof e.cluster.getMarkers === 'function') {
              try {
                markers = e.cluster.getMarkers() || []
                if (totalCount > 0 && markers.length >= totalCount) {
                  markers = []
                } else {
                  console.log('触发22', markers.length)
                }
              } catch (err) {
                markers = []
              }
            }

            //根据点击位置附近筛选
            if (!markers || markers.length === 0) {
              let center = null
              try {
                if (e && e.lnglat) {
                  center = [e.lnglat.lng || (e.lnglat.getLng && e.lnglat.getLng()), e.lnglat.lat || (e.lnglat.getLat && e.lnglat.getLat())]
                } else if (e && e.target && typeof e.target.getPosition === 'function') {
                  const p = e.target.getPosition()
                  center = [p.lng || (p.getLng && p.getLng()), p.lat || (p.getLat && p.getLat())]
                }
              } catch (err) {
                center = null
              }

              if (!center) {
                console.warn('错误111')
                return
              }

              const threshold = 50 // meters
              const listData = []
              for (const item of formData.data) {
                const d = distanceMeters(center[0], center[1], item.lng, item.lat)
                if (d <= threshold) listData.push(item)
              }
              formData.list = listData.map(it => Object.assign({ id: it.id }, it))
              formData.title = formData.list.length + ' devices'
              formData.visible = formData.list.length > 0
              formData.showEQBox = false
              console.log('列表数据333',formData.list)
              return
            }
            console.log('触发333')
            // 否则使用 markers 列表
            const list = []
            for (const m of markers) {
              let ext = {}
              try {
                ext = (typeof m.getExtData === 'function') ? m.getExtData() : (m.w && m.w.extData ? m.w.extData : {})
              } catch (err) {
                ext = m.w && m.w.extData ? m.w.extData : {}
              }
              if (!ext || !ext.id) continue
              const data = getDataById(ext.id) || {}
              if (data && Object.keys(data).length) list.push(Object.assign({ id: ext.id }, data))
            }
            
            formData.list = list
            formData.title = list.length + ' devices'
            formData.visible = true
            formData.showEQBox = false
          } catch (err) {
            console.error('cluster click inner error', err)
          }
        })
      } catch (err) {
        console.warn('markerCluster click bind failed', err)
      }

      // 点击地图任意位置关闭聚合列表
      map.on && map.on('click', () => {
        func.doHideClusterList()
      })

    }
    const getMarkerIcon = (item) => {
      let name = ""
      let status = "online"
      if (item.status != t('device.statuses.online')) status = "offline";
      if (item.type == 1) {
        name = "box"
      } else if (item.type == 2) {
        name = "battery"
      } else if (item.type == 3) {
        name = "pile"
      } else {
        name = "cpbox"
      }
      const image = require('@/assets/img/' + name + '-' + status + '.png')
      const icon = new AMap.Icon({
        size: new AMap.Size(32, 41),
        image,
      });
      return icon
    }
    const distanceMeters = (lng1, lat1, lng2, lat2) => {
      const toRad = (v) => v * Math.PI / 180
      const R = 6371000
      const dLat = toRad(lat2 - lat1)
      const dLon = toRad(lng2 - lng1)
      const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
        Math.sin(dLon/2) * Math.sin(dLon/2)
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a))
      return R * c
    }
    const getEqs = async () => {

        let params = {
          getAll: 1,
        }
        if(formData.CodePathID){
          params.CodePathID = formData.CodePathID
        }
        params.isstartwith = formData.isstartwith
        let res = await axios.get(`/admin/box`, {
          params
        });


        let data = []
        for (const item of res.List) {
          if(item.Latitude==0&&item.Longitude==0){
            continue;
          }
          let imgs = []
          if(item.ImgBox)imgs.push(item.ImgBox);
          if(item.ImgStore)imgs.push(item.ImgStore);
          if(item.ImgStreet)imgs.push(item.ImgStreet);
          let obj = {
            id:item.Id,
            // lat:Math.round(item.Latitude*1000000)/1000000,
            // lng:Math.round(item.Longitude*1000000)/1000000,
            lat:item.Latitude,
            lng:item.Longitude,
            type:item.Type,
            name:item.Name,
            saveMoney:item.SaveMoney,
            chargeMoney:item.ChargeMoney,
            status:(item.Status == 1 && item.Alert === 0)?t('device.statuses.online'):t('device.statuses.offline'),
            address:item.Address || t('common.out_of_sync'),
            devId:item.DevId,
            agentCode:item.AgentCode,
            CodePath:item.CodePath,
            siteName:item.SiteName,
            slotNum:item.SlotNum,
            slotNumErr:item.SlotNumErr,
            slotNumEm:item.SlotNumEm,
            deposit:item.Deposit,
            imgs,
            tel:"",
            contacts:"",
          }
          data.push(obj)
        }
        return data
    }

    onMounted(async () => {
      
      dataFilter()
    })
    initMap()
    onBeforeUnmount(() => {
      // 销毁地图，防止卡顿
      map.destroy()
      if (myChart) {
        myChart.dispose();
      }
    })

    return {
      formData,
      operators,
      func,
      cascade_options_direct,
      handleClusterItemClick
    }
  }
}
</script>
<style lang="scss">
.e-search .el-select-dropdown__item {
  height: 3.76rem;
  line-height: 1.625rem;

  .option-custom {
    .option-label {
      font-size: 0.875rem;
    }

    .option-address {
      font-size: 0.75rem;
      display: block;
      color: #909399;
    }
  }

  &.hover,
  .selected {
    .option-label {
      color: #409eff;
    }

    .option-address {
      color: #409eff99;
    }
  }
}
</style>
<style lang="scss" scoped>
.content {
  position: relative;
  height: 100%;
  padding: 0px;

  #map {
    width: 100%;
    // height: 100%;
    height: calc(100% - 30px);
  }
}

.map-filter {
  position: absolute;
  top: 15px;
  left: 12px;
  z-index: 9999;
  width: 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0;

  .e-select {
    width: 210px;

    &.e-select-first {
      margin-right: 0.5rem;
    }
  }
}
.cluster-list-ct {
  position: absolute;
  right: 12px;
  top: 70px;
  z-index: 10000;
  background: rgba(255,255,255,0.98);
  box-shadow: 0 2px 8px rgba(0,0,0,0.12);
  border-radius: 6px;
  max-height: 60vh;
  overflow: auto;
}
.cluster-list { 
  padding: 8px;
  min-width: 240px; 
}
.cluster-title {
  font-weight: 600;
  margin-bottom: 6px;
 }
.cluster-item { 
  padding: 8px;
  border-radius: 4px;
  cursor: pointer;
 }
.cluster-item:hover {
  background: #f5f7fa;
}
.cluster-item .meta {
  font-size: 12px;
  color: #909399;
}

.map-options {
  position: absolute;
  bottom: 2.6rem;
  right: 1.25rem;
  background: #fff;
  z-index: 9999;
  padding: 0.275rem 0.8rem;
  border-radius: 0.5rem;
  max-width: 85%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  .switch-txt {
    font-size: 0.875rem;
    margin-left: 0.625rem;
    color: #606266;
    font-weight: 500;

    &.switch-txt-online {
      margin-right: 1.25rem;
    }

    &.switch-txt-offline {}
  }
}

.eq-box-ct {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;

  .eq-box {
    margin-left: 5.25rem;
    margin-top: 4rem;
    background-color: #fff;
    width: 20rem;
    border-radius: 0.3125rem;
    box-sizing: border-box;
    padding: 0.75rem;

    .chart {
      width: 14rem;
      height: 16rem;
      margin: 0 auto;
    }

    .title {
      font-size: 1.2rem;
      padding: 0.9375rem 0;
    }

    .item {
      text-align: left;
      margin-bottom: 0.625rem;
      font-size: 0.875rem;

      .label {
        font-weight: 500;
        margin-right: 0.5rem;

        &:nth-child(3) {
          margin-left: 3.125rem;
        }
      }

      .val {
        &.status {
          color: #F56C6C;
        }

        &.active {
          color: #67C23A;
        }
      }
    }

    .img-ct {
      display: flex;
      justify-content: space-between;

      :deep(img) {
        object-fit: cover;
      }

      .img {
        width: 6rem;
        height: 7rem;
        border-radius: 0.25rem;
      }
    }
  }
}
</style>